<script>
import ExportPresentationJobService from '@src/services/ExportPresentationJobService'
import {
    buildExportJobTimeoutPatches,
    isExportJobPollingCandidate,
} from '@src/utils/exportJobTimeout'

const POLL_MS = 5000

export default {
    data() {
        return {
            presentationExportJobPollTimer: null,
            presentationExportJobPollInFlight: false,
        }
    },
    mounted() {
        this.presentationExportJobOnVisibilityHandler = () => {
            if (!document.hidden) {
                this.ensurePresentationExportJobPolling()
            }
        }
        document.addEventListener(
            'visibilitychange',
            this.presentationExportJobOnVisibilityHandler
        )
    },
    beforeDestroy() {
        this.clearPresentationExportJobPolling()
        if (this.presentationExportJobOnVisibilityHandler) {
            document.removeEventListener(
                'visibilitychange',
                this.presentationExportJobOnVisibilityHandler
            )
            this.presentationExportJobOnVisibilityHandler = null
        }
    },
    methods: {
        presentationExportJobIsInProgress(row) {
            return isExportJobPollingCandidate(row)
        },

        applyPresentationExportJobTimeoutPatches() {
            const rows = this.getPresentationExportJobsTableRows()
            const patches = buildExportJobTimeoutPatches(rows)
            if (patches.length === 0) {
                return
            }
            const wrapper = this.$refs.vuetable
            if (wrapper && typeof wrapper.patchTableRows === 'function') {
                wrapper.patchTableRows(patches)
            }
        },

        getPresentationExportJobsTableRows() {
            const wrapper = this.$refs.vuetable
            if (!wrapper || typeof wrapper.getTableRows !== 'function') {
                return []
            }
            return wrapper.getTableRows()
        },

        clearPresentationExportJobPolling() {
            if (this.presentationExportJobPollTimer) {
                clearInterval(this.presentationExportJobPollTimer)
                this.presentationExportJobPollTimer = null
            }
        },

        ensurePresentationExportJobPolling() {
            this.$nextTick(() => {
                this.applyPresentationExportJobTimeoutPatches()
                const rows = this.getPresentationExportJobsTableRows()
                const hasInProgress = rows.some((r) =>
                    this.presentationExportJobIsInProgress(r)
                )
                if (hasInProgress) {
                    if (!this.presentationExportJobPollTimer) {
                        this.pollPresentationExportJobProgressOnce()
                        this.presentationExportJobPollTimer = setInterval(
                            () => this.pollPresentationExportJobProgressOnce(),
                            POLL_MS
                        )
                    }
                } else {
                    this.clearPresentationExportJobPolling()
                }
            })
        },

        async pollPresentationExportJobProgressOnce() {
            if (document.hidden || this.presentationExportJobPollInFlight) {
                return
            }
            this.applyPresentationExportJobTimeoutPatches()
            const rows = this.getPresentationExportJobsTableRows()
            const ids = rows
                .filter((r) => this.presentationExportJobIsInProgress(r))
                .map((r) => r.id)
            if (ids.length === 0) {
                this.clearPresentationExportJobPolling()
                return
            }
            const payload = {
                ids,
                ...this.additionalParameters,
            }
            this.presentationExportJobPollInFlight = true
            try {
                const res =
                    await ExportPresentationJobService.fetchExportPresentationJobProgress(
                        payload
                    )
                const list = res.data && res.data.data
                const wrapper = this.$refs.vuetable
                if (
                    list &&
                    Array.isArray(list) &&
                    wrapper &&
                    typeof wrapper.patchTableRows === 'function'
                ) {
                    wrapper.patchTableRows(list)
                }
            } catch (e) {
                // Polling is best-effort; avoid breaking the page on network errors.
            } finally {
                this.presentationExportJobPollInFlight = false
                this.ensurePresentationExportJobPolling()
            }
        },
    },
}
</script>
